<template>
  <div class="animated fadeIn">
    <div v-if="!$route.params.id" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" />
            Media files
          </div>
          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by media file name"
            >
          </div>
          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <div class="text-center">
              <div class="pie-wrap">
                <spinner ref="pieSpinner" size="md" text="Loading chart data" />

                <div v-if="pieDataHasError" class="pie-error-wrap">
                  Server error. Try to reload chart
                </div>

                <pie-chart
                  v-if="pieDataIsReady"
                  :data="pieData"
                  :options="pieOptions"
                  :width="500"
                  :height="250"
                />

                <button class="btn btn-primary mt-3" @click="getPieData">Reload chart</button>
              </div>
            </div>
            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
            <div class="table-responsive">
              <table class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Media ID</th>
                    <th>Media Type</th>
                    <th>File name</th>
                    <th>Disk</th>
                    <th>Status</th>
                    <th>Last Check</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td />
                    <td />
                    <td>
                      <select v-model="filters.model_type" class="form-control">
                        <option value="">Any</option>
                        <option
                          v-for="(value, key) in contentTypes"
                          :key="value.namespace"
                          :value="value.namespace"
                        >
                          {{ key }}
                        </option>
                      </select>
                    </td>
                    <td />
                    <td>
                      <select v-model="filters.disk" class="form-control">
                        <option value="">Any</option>
                        <option value="media">media</option>
                        <option value="selectel">selectel</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="filters.status" class="form-control">
                        <option value="">Any</option>
                        <option value="ok">ok</option>
                        <option value="failed">failed</option>
                      </select>
                    </td>
                    <td />
                    <td />
                  </tr>
                  <tr v-for="item in media" :key="item.id" :data-id="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.model_id }}</td>
                    <td>{{ item.model_type }}</td>
                    <td>
                      <a :href="item.public_url" download>{{ item.file_name }}</a>
                    </td>
                    <td>{{ item.disk }}</td>
                    <td class="text-center table-cell-loader-parent">
                      <span v-if="!item.file_health">null</span>
                      <i
                        v-else-if="item.file_health.status==='ok'"
                        class="fa fa-check text-success"
                      />
                      <i
                        v-else-if="item.file_health.status==='failed'"
                        class="fa fa-times text-danger"
                      />
                      <span class="table-cell-loader" style="display: none;" />
                    </td>
                    <td class="table-cell-loader-parent">
                      {{ item.file_health ? item.file_health.date : '' }}
                      <span class="table-cell-loader" style="display: none;" />
                    </td>
                    <td class="table-cell-loader-parent">
                      <button class="btn btn-primary btn-update" @click="updateHealth(item)">
                        Update status
                      </button>
                      <span class="table-cell-loader" style="display: none;" />
                    </td>
                  </tr>
                  <tr>
                    <td v-if="!total" colspan="8">There are no items on your request</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
import PieChart from '@/global/components/PieChart';
// Mixins
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'Media',

  components: {
    pager: Pager,
    'pie-chart': PieChart,
  },

  mixins: [ListPageMixin, CommonPageMixin],

  data() {
    return {
      pieDataIsReady: false,
      pieDataHasError: false,
      pieOptions: {
        responsive: false,
        maintainAspectRatio: false,
        legend: {
          labels: {
            defaultFontSize: 14,
          },
        },
      },
      helthStats: {
        all: 0,
        noInfo: 0,
        helth: 0,
        damaged: 0,
      },
      filters: {
        status: '',
        disk: '',
        model_type: '',
      },
      contentTypes: {},
      media: null,
    };
  },

  computed: {
    pieData() {
      return {
        labels: [
          `Ok (${this.helthStats.helth})`,
          `Failed (${this.helthStats.damaged})`,
          `Unknown (${this.helthStats.noInfo})`,
        ],
        datasets: [
          {
            label: 'File Helth',
            backgroundColor: ['#4dbd74', '#f86c6b', '#5a5a5a'],
            data: [this.helthStats.helth, this.helthStats.damaged, this.helthStats.noInfo],
          },
        ],
      };
    },
  },

  watch: {
    'filters.status': function () {
      this.getSource();
    },
    'filters.disk': function () {
      this.getSource();
    },
    'filters.model_type': function () {
      this.getSource();
    },
  },

  mounted() {
    this.getPieData();
    this.contentTypes = this.$store.state.contentTypes.list;
    this.$store.watch(state => state.contentTypes.list, () => {
      this.contentTypes = this.$store.state.contentTypes.list;
    }, { deep: true });
  },

  methods: {
    getPieData() {
      const successFinish = (queryCount) => {
        if (queryCount === 0) {
          this.helthStats.noInfo = this.helthStats.all - this.helthStats.damaged - this.helthStats.helth;
          this.pieDataIsReady = true;
          if (this.$refs.pieSpinner) { this.$refs.pieSpinner.hide(); }
        }
      };
      let queryCount = 3;

      this.pieDataIsReady = false;
      this.pieDataHasError = false;
      if (this.$refs.pieSpinner) { this.$refs.pieSpinner.show(); }

      this.$apiHttp.get(`${this.$config.app_api.prefix}medialibrary`)
        .then((response) => {
          this.helthStats.all = response.data.meta.pagination.total;
          queryCount -= 1;
          successFinish(queryCount);
        }).catch((error) => {
          this.pieDataHasError = true;
          console.error(error);
        });
      this.$apiHttp.get(`${this.$config.app_api.prefix}medialibrary?filter_status=ok`)
        .then((response) => {
          this.helthStats.helth = response.data.meta.pagination.total;
          queryCount -= 1;
          successFinish(queryCount);
        }).catch((error) => {
          this.pieDataHasError = true;
          console.error(error);
        });
      this.$apiHttp.get(`${this.$config.app_api.prefix}medialibrary?filter_status=failed`)
        .then((response) => {
          this.helthStats.damaged = response.data.meta.pagination.total;
          queryCount -= 1;
          successFinish(queryCount);
        }).catch((error) => {
          this.pieDataHasError = true;
          console.error(error);
        });
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}medialibrary`, {
        params: {
          search_string: searchString,
          page,
          filter_status: this.filters.status,
          filter_disk: this.filters.disk,
          filter_model_type: this.filters.model_type,
        },
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.total = response.data.meta.pagination.total;
          this.perPage = response.data.meta.pagination.per_page;

          const mediaArr = _.cloneDeep(response.data);
          delete mediaArr.meta;
          this.media = mediaArr;
        }
      }).catch((error) => { this.$_errorCallback(error); });
    },
    updateHealth(mediaItem) {
      const $btnsUpdateLoader = $(`table.entities tr[data-id="${mediaItem.id}"] .table-cell-loader`);
      $btnsUpdateLoader.show();
      this.$apiHttp.post(`${this.$config.app_api.prefix}medialibrary/${mediaItem.id}/check-health`)
        .then((response) => {
          const key = _.findKey(this.media, item => mediaItem.id === item.id);
          this.media[key].file_health = response.data;
          $btnsUpdateLoader.hide();
          this.$store.commit('notifications/setSuccessNotification', 'Updated');
        })
        .catch((error) => {
          $btnsUpdateLoader.hide();
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in updating media status' });
          console.error(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?38acb54d